// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1kJWx","name":"ConsentHeader_name__3kIZN","birthday":"ConsentHeader_birthday___aYao","skeleton":"ConsentHeader_skeleton__1BcMF"};